// video player based on YouTube iFrame API, see: https://developers.google.com/youtube/iframe_api_reference
// should you need more robust implementation, see: https://github.com/gajus/youtube-player
export let player = {

	selectorComponent : '.video-component',
	selectorPlayer : '.video__player',
	selectorButton : '.do-play-video',

	players : [], //store players in array to allow control of multiple instances

    isPlayerReady : false,

	init : function() {

        //This code loads the IFrame Player API code asynchronously.
		let tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
	    
	    let firstScriptTag = document.getElementsByTagName('script')[0];

	    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        //Any web page that uses the IFrame API must also implement the following JavaScript function (that needs to be available from global scope, see: https://stackoverflow.com/a/15375225/17192641)
        window.onYouTubeIframeAPIReady = this.playerReady(true);
	
	},

	bind : function() {

		if( document.querySelector(this.selectorComponent) === null ) return;

		let self = this;

		//init youtube api 
		this.init();

		//bind video play logic to buttons
		let buttons = document.querySelectorAll(this.selectorButton);

		buttons.forEach( function(item) {

			item.addEventListener('click', function(event) {

				let parent = this.closest(self.selectorComponent);
				let videoId = parent.dataset.videoId;
				let player = parent.querySelector(self.selectorPlayer);

				if( parent.dataset.state === 'paused' ) {
					self.resume(videoId);
				} else {
					self.play(player, videoId);
				}

				event.preventDefault();

			});

		});			

	},

	play : function(player, videoId) {

        if(!this.isPlayerReady) return;

		let self = this;
		
		let parent = player.closest(self.selectorComponent);
		let title = parent.dataset.title;
		//console.log(this.player);

		//update state immediately on button click rather than waiting for YT response,
		//at worst case scenario user will see yt preloader/buffering state but won't perceive
		//that "nothing is happeing"
		parent.dataset.state = 'started';

        //This code creates an <iframe> (and YouTube player) after the API code downloads.
		this.players.push({ 
			videoId,
			'player': new YT.Player(player, {
				title : title,
				videoId: videoId,
				width: '100%',
				height: '100%',
				playerVars: {
					controls: 1,
					autoplay: 1,
					rel: 0,
					showinfo: 0,
					modestbranding: 0
				},
				events: {
					'onStateChange': (event) => {
						self.updateState(event, parent, self)
					}
				}	      		
			})
		});
		
		//Center element in view, but wait till the container transition ends (see _scss/components/video.scss) (this messes up modal layout)
		// setTimeout( () => {
		// 	parent.scrollIntoView({
		// 		block : 'center',
		// 		behavior : 'smooth',
		// 	});
		// }, 500);


	},

	resume : function(videoId) {
		if(!this.players.length) return;

		let video = this.players.find(player => player.videoId === videoId);

		video.player.playVideo();

	},

	destroy : function(videoId) {
		if(!this.players.length) return;
		
		let video = this.players.find(player => player.videoId === videoId);

		video.player.destroy();

		//remove current player from players array
		let players = this.players.filter(player => player.videoId !== videoId);
		this.players = players;	

		//TO DO: if there is video-component with status "playing" or "paused" with the same video id it will became unfunctional, so we need to either differentiate video id with key pointing to the specific container (modal vs section) or reset state data-attribute

	},	

	updateState : function(event, parent, self) {

		if( event.data == YT.PlayerState.PLAYING ) {
			parent.dataset.state = 'playing';
		}

		if( event.data == YT.PlayerState.PAUSED) {

			// //update state if video is paused but only after couple of second to avoid toggling back poster while interacting with progress bar
			setTimeout( function() {

				//check if video is still paused...
				let videoId = parent.dataset.videoId;
				let video = self.players.find(player => player.videoId === videoId);

				if(!video) return;
				
				if( video.player.getPlayerState() == YT.PlayerState.PAUSED ) {
					parent.dataset.state = 'paused';
				}

			}, 3000);
			
		}

		if( event.data == YT.PlayerState.ENDED ) {
			parent.dataset.state = 'ended';			
		}

	},

    playerReady : function(ready) {
        if(ready === true) {
            this.isPlayerReady = true;
            console.log('YouTube player ready');
        } else {
            this.isPlayerReady = false;
            console.log('YouTube player not ready');
        }
    }

}